"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAuthFileUrl = exports.uploadAuthFile = exports.uploadFile = exports.getToken = exports.getBaseUrl = exports.getCodeInfoFromDomain = exports.getEnv = exports.getSignString = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const hostConfig = {
  dev: ['-dev'],
  canary: ['-test', 'dev.yposxdev.wywk.cn'],
  uat: ['-uat'],
  prod: ['wywk.cn', 'wy-hotel.cn', 'wanyoo.com']
};
const signKey = '123456abcdef!@#';

const getSignString = cusTimeStamp => {
  const timeStamp = new Date().getTime();
  const str = signKey + (cusTimeStamp || timeStamp);
  const encodeStr = encodeURI(str);
  const base64 = btoa(encodeStr);
  return base64;
};

exports.getSignString = getSignString;

const getEnv = () => {
  const env = 'dev';

  if (typeof document !== 'undefined') {
    const host = document.domain.toLowerCase();

    if (host.includes(hostConfig.dev[0])) {
      return 'dev';
    }

    if (host.includes(hostConfig.canary[0]) || host.includes(hostConfig.canary[1])) {
      return 'canary';
    }

    if (host.includes(hostConfig.uat[0])) {
      return 'uat';
    }

    if (hostConfig.prod.some(url => host.includes(url))) {
      return 'prod';
    }

    return env;
  }

  return 'dev';
};

exports.getEnv = getEnv;

const getCodeInfoFromDomain = url => {
  var _code$match, _envStr$match;

  const parsedUrl = new URL(url || window.location.href);
  const domain = parsedUrl.hostname;
  const parts = domain.split('.');
  const code = parts.slice(-3, -2)[0] || '';
  const apiThirdLevel = code.match(/^[a-zA-Z]+/) ? (_code$match = code.match(/^[a-zA-Z]+/)) === null || _code$match === void 0 ? void 0 : _code$match[0] : '';
  const envStr = parts.slice(0, 1)[0] || '';
  const env = envStr.match(/-(\w+)$/) ? (_envStr$match = envStr.match(/-(\w+)$/)) === null || _envStr$match === void 0 ? void 0 : _envStr$match[0] : '';
  return {
    env,
    code: code,
    apiThirdLevel
  };
};

exports.getCodeInfoFromDomain = getCodeInfoFromDomain;

const dynamicApIUrl = () => {
  const {
    env,
    apiThirdLevel
  } = getCodeInfoFromDomain();
  return `https://mop-web${env ? `${env}` : ''}.${apiThirdLevel}.wanyoo.com`;
};

const isOversea = url => {
  const parsedUrl = new URL(url || window.location.href);
  const domain = parsedUrl.hostname;
  return domain.includes('.wanyoo.com') && !domain.includes('localhost');
};

const getBaseUrl = () => {
  const tokenBaseUrlMap = {
    dev: 'https://eoms-login-test.wywk.cn/',
    canary: 'https://eoms-login-test.wywk.cn/',
    uat: 'https://eoms-login-uat.wywk.cn/',
    prod: 'https://eoms-login.wywk.cn/'
  };
  const ufsBaseUrlMap = {
    dev: 'https://ufs-test.wywk.cn/',
    canary: 'https://ufs-test.wywk.cn/',
    uat: 'https://ufs-uat.wywk.cn/',
    prod: 'https://ufs.wywk.cn/'
  };
  const overSeaufsBaseUrlMap = {
    dev: 'https://ufs-test.wywk.cn/',
    canary: 'https://ufs-test.wywk.cn/',
    uat: 'https://ufs-uat.wywk.cn/',
    prod: 'https://file-component-service.wanyoo.com/'
  };
  const env = getEnv();
  const newOss = isOversea() && env === 'prod';
  return {
    tokenBaseUrl: newOss ? dynamicApIUrl() : tokenBaseUrlMap[env],
    ufsBaseUrl: newOss ? overSeaufsBaseUrlMap[env] : ufsBaseUrlMap[env]
  };
};

exports.getBaseUrl = getBaseUrl;
const {
  tokenBaseUrl,
  ufsBaseUrl
} = getBaseUrl();

const http = _axios.default.create({
  timeout: 60 * 1000,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
});

http.interceptors.request.use(config => {
  return _objectSpread(_objectSpread({}, config), {}, {
    headers: _objectSpread({}, config.headers)
  });
});
http.interceptors.response.use(res => {
  if (res.data.code !== 0) {
    console.log(`Error: ${res.data.message || res.data.msg}`);
  }

  return res.data;
});

const getToken = async cusTimeStamp => {
  const res = await http({
    baseURL: tokenBaseUrl,
    url: isOversea() && getEnv() === 'prod' ? '/mop-web/file/token' : '/file/token',
    method: 'GET',
    params: {
      sign: getSignString(cusTimeStamp)
    }
  });
  const {
    code,
    data
  } = res || {};
  if (code === 0) return data;
  return {
    expire: 0,
    token: ''
  };
};

exports.getToken = getToken;

const uploadFile = async (formData, httpConfig = {}) => {
  const {
    token
  } = await getToken();
  const res = await http(_objectSpread(_objectSpread({
    baseURL: ufsBaseUrl,
    url: '/web/file/v1/upload2AliOss',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      token
    }
  }, httpConfig), {}, {
    transformResponse: [data => {
      const result = JSON.parse(data);

      if (result.code === 200) {
        return _objectSpread(_objectSpread({}, result), {}, {
          code: 0
        });
      }

      return result;
    }]
  }));
  return res;
};

exports.uploadFile = uploadFile;

const uploadAuthFile = async (formData, httpConfig = {}) => {
  const {
    token
  } = await getToken();
  const res = await http(_objectSpread(_objectSpread({
    baseURL: ufsBaseUrl,
    url: '/web/file/v2/uploadAuthFile2AliOss',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      token
    }
  }, httpConfig), {}, {
    transformResponse: [data => {
      const result = JSON.parse(data);

      if (result.code === 200) {
        return _objectSpread(_objectSpread({}, result), {}, {
          code: 0
        });
      }

      return result;
    }]
  }));
  return res;
};

exports.uploadAuthFile = uploadAuthFile;

const getAuthFileUrl = async (data, httpConfig = {}) => {
  const {
    token
  } = await getToken();
  const res = await http(_objectSpread(_objectSpread({
    baseURL: ufsBaseUrl,
    url: '/web/file/v2/getAuthFile2AliOss',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      fileToken: token
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  }, httpConfig), {}, {
    transformResponse: [data => {
      const result = JSON.parse(data);

      if (result.code === 200) {
        return _objectSpread(_objectSpread({}, result), {}, {
          code: 0
        });
      }

      return result;
    }]
  }));
  return res;
};

exports.getAuthFileUrl = getAuthFileUrl;